export const title = 'Campaign sales';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.en.mdx';

Number of sales attributed to campaigns in the selected period.

<CampaignAttributionDateNote />
